"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var ControlAreaBuilding = /*#__PURE__*/function () {
  function ControlAreaBuilding(opt) {
    _classCallCheck(this, ControlAreaBuilding);

    this._id = null;
    this.name = null;
    this.campusCode = null;
    this.tenantCode = null;
    this.address = null;
    this.codeYear = null;
    this.fireSuppressionCoverage = false;
    this.floors = [];

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(ControlAreaBuilding, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this._id = opt._id || null;
      this.name = opt.name || null;
      this.campusCode = opt.campusCode || null;
      this.tenantCode = opt.tenantCode || null;
      this.address = opt.address || null;
      this.codeYear = opt.codeYear || null;
      this.fireSuppressionCoverage = !!opt.fireSuppressionCoverage || false;
      this.floors = opt.floors || [];
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, ControlAreaBuilding.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'control-area-building.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: 'string'
          },
          name: {
            type: 'string'
          },
          campusCode: {
            type: 'string'
          },
          tenantCode: {
            type: 'string'
          },
          address: {
            type: 'string'
          },
          codeYear: {
            type: 'number'
          },
          fireSuppressionCoverage: {
            type: 'boolean'
          },
          floors: {
            type: 'array',
            item: {
              type: 'object',
              properties: {
                floorId: {
                  type: ['null', 'string']
                },
                floorName: {
                  type: ['null', 'string']
                },
                level: {
                  type: ['null', 'number']
                }
              }
            }
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return ControlAreaBuilding;
}();

module.exports = ControlAreaBuilding;